/**
 * Profile API Service
 * Handles all profile-related API calls
 */

import httpClient from './httpClient';

export const profileApiService = {
  /**
   * Get current user profile
   */
  getCurrentUserProfile: async () => {
    const response = await httpClient.get('/profile/user');
    return response;
  },

  /**
   * Upload company logo
   */
  uploadCompanyLogo: async (logoFile) => {
    const formData = new FormData();
    formData.append('logo', logoFile);
    
    const response = await httpClient.post('/profile/company-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },

  /**
   * Get company logo info
   */
  getCompanyLogoInfo: async () => {
    const response = await httpClient.get('/profile/company-logo');
    return response;
  },

  /**
   * Get company logo image URL
   */
  getCompanyLogoImageUrl: () => {
    return `${httpClient.getInstance().defaults.baseURL}/profile/company-logo/image`;
  },

  /**
   * Get company logo image as blob URL (with authentication)
   * This fetches the image with JWT token and returns a blob URL
   */
  getCompanyLogoImageBlob: async () => {
    try {
      const axiosInstance = httpClient.getInstance();
      const response = await axiosInstance.get('/profile/company-logo/image', {
        responseType: 'blob',
      });
      
      // Create a blob URL from the response
      const blob = response.data;
      const blobUrl = URL.createObjectURL(blob);
      return blobUrl;
    } catch (error) {
      console.error('Failed to fetch company logo:', error);
      return null;
    }
  },

  /**
   * Update user profile
   */
  updateUserProfile: async (profileData) => {
    const response = await httpClient.put('/profile/user', profileData);
    return response;
  },
};